<template>
    <div class="hot-question-edit">
        <div class="hot-edit-content" @mousemove="moveHandle" @mouseout="outHandle">
            <IconInput class="hot-question-title" :initValue="data.hotTitle" @inputChange="titleChange" :placeholder="titleLabel" />
            <div class="linked-question-search">
                <QuestionSearch
                    class="question-search"
                    :questionId="data.questionId"
                    :question="data.question"
                    @questionSelected="questionSelected"
                />
            </div>
            <div class="delete-icon">
                <Icon v-show="canDelete && showDelete" @iconClick="deleteHandle" :bgPosition="bgPosition" :hoverBgPosition="hoverBgPosition" />
            </div>
        </div>
    </div>
</template>

<script>
import Icon from "@/views/zhiji/bComponents/icons/Icon";
import IconInput from "@/views/zhiji/bComponents/inputs/IconInput";
import QuestionSearch from "@/views/zhiji/components/questionSearch/QuestionSearch";

export default {
    name: "HotEditItem",
    props: ["data", "parentUId", "count"],
    components: {
        Icon,
        IconInput,
        QuestionSearch
    },
    data() {
        return {
            bgPosition: "-94px 0",
            hoverBgPosition: "-94px -22px",
            showDelete: false
        };
    },
    computed: {
        titleLabel() {
            return this.$t("zhiji.answer.hotTitleTip");
        },
        canDelete() {
            return this.count > 2;
        }
    },
    methods: {
        titleChange(data) {
            this.commitUpdate({
                hotTitle: data
            });
        },
        questionSelected(data) {
            this.commitUpdate({
                questionId: data.questionId + "",
                question: data.question
            });
        },
        deleteHandle() {
            this.$emit("deleteItem", this.data.uId);
        },
        moveHandle() {
            this.showDelete = true;
        },
        outHandle() {
            this.showDelete = false;
        },
        commitUpdate(widget) {
            widget.uId = this.data.uId;
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "updateContentItem",
                widget: {
                    uId: this.parentUId,
                    item: widget
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.hot-question-edit {
    display: flex;
    .hot-edit-content {
        display: flex;
        .hot-question-title {
            width: 250px;
            background: #fff;
            margin-right: 10px;
            border: solid 1px #d8e4f0;
            border-radius: 4px;
        }
        .linked-question-search {
            margin-right: 10px;
        }
    }
    .delete-icon {
        line-height: 32px;
        width: 18px;
    }
}
</style>
